import { Grid } from "@material-ui/core";
import { Link } from "react-router-dom";
import logo from "../assets/stoqqyLogo.svg";
import info from "../assets/info.png";
import Searchbar from "./Searchbar";
import { useSelector, useDispatch } from "react-redux";
import cameraIcon from "../assets/camera.svg";
import { useState } from "react";
import InfoPopup from "./InfoPopup";
import { setCamera } from "../redux/camera";
import Alpha from "./Alpha";
import LanguageMenu from "./LanguageMenu";

export default function Header(props) {
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const isLargeDesktop = useSelector((state) => state.isLargeScreen.value);
  const innerWidth = useSelector((state) => state.innerWidth.value);
  const camera = useSelector((state) => state.camera.value);
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const placeHolder = props.placeHolder;

  return (
    <div
      style={{
        padding: isDesktopOrLaptop
          ? props?.fixed
            ? "23px 0px 22px 98px"
            : "35px 0px 35px 98px"
          : !props?.fixed
          ? "14px 15px 15px 11px"
          : "14px 15px 2px 11px",
        backgroundColor: "#f8f8f8",
        paddingLeft: isDesktopOrLaptop
          ? innerWidth > 1440
            ? (innerWidth - 1440) / 2 + 98
            : 98
          : 11,
        boxShadow: props?.fixed ? "0 2px 9px 0 #00000040" : "",
      }}
    >
      <InfoPopup anchorEl={anchorEl} setAnchorEl={setAnchorEl} t={props.t} />
      <Grid container alignItems="center">
        <Grid
          item
          xs={isDesktopOrLaptop ? "auto" : 6}
          style={{ display: "flex", alignItems: "center" }}
        >
          <Link to="/home">
            <img
              src={logo}
              alt="logo"
              width={isDesktopOrLaptop ? "151px" : "100px"}
              style={{
                margin: "8px 10px 0px 0",
              }}
            />
          </Link>
          <div
            style={{
              width: "82px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <LanguageMenu />
          </div>
        </Grid>
        {isDesktopOrLaptop ? (
          <Grid
            item
            style={{
              height: "40px",
            }}
          >
            <div style={{ width: "757px" }}>
              <Searchbar height="40px" placeHolder={placeHolder} />
            </div>
          </Grid>
        ) : null}
        {!props.fixed ? (
          <Grid
            item
            xs={isDesktopOrLaptop ? "auto" : 6}
            style={{
              height: isDesktopOrLaptop ? "40px" : "35px",
              width: isDesktopOrLaptop ? "auto" : "35px",
              display: "flex",
              justifyContent: "flex-end",
              justifySelf: "flex-end",
              paddingLeft: isDesktopOrLaptop ? "69px" : "0px",
            }}
          >
            <div
              style={{
                height: isLargeDesktop ? "37px" : "35px",
                width: isLargeDesktop ? "175px" : "35px",
                borderRadius: isLargeDesktop ? "32.5px" : "50%",
                border: isLargeDesktop
                  ? "solid 1.5px #808080"
                  : "solid 1px #979797",
                fontFamily: "Overpass",
                fontsize: "14px",
                color: "#808080",
                textTransform: "unset",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={(e) => {
                setAnchorEl(e.currentTarget);
              }}
            >
              {isLargeDesktop ? (
                <span
                  style={{
                    fontSize: "14px",
                    paddingTop: "4px",
                    userSelect: "none",
                  }}
                >
                  {props.t("guide")}
                </span>
              ) : null}
              <img
                src={info}
                alt="info"
                style={{
                  paddingLeft: isLargeDesktop ? "10px" : "0px",
                  width: "5px",
                  paddingBottom: "2px",
                }}
              />
            </div>
            {isDesktopOrLaptop ? null : (
              <div
                style={{
                  height: "35px",
                  width: "35px",
                  borderRadius: "50%",
                  marginLeft: "18px",
                  backgroundColor: "#0040ff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
                onClick={() => {
                  dispatch(setCamera({ ...camera, isOpen: true }));
                }}
              >
                <img
                  src={cameraIcon}
                  alt="camera"
                  style={{
                    paddingLeft: isLargeDesktop ? "10px" : "0px",
                    width: "19px",
                  }}
                />
              </div>
            )}
          </Grid>
        ) : null}
        {isDesktopOrLaptop ? null : props.fixed ? (
          <>
            <Grid
              item
              xs={6}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Alpha height="27px" width="132px" t={props.t} />
            </Grid>
            <Grid item xs={12} style={{ marginTop: "33px" }}>
              <Searchbar unfocused={true} placeHolder={placeHolder} />
            </Grid>
          </>
        ) : null}
      </Grid>
    </div>
  );
}
